export default __webpack_public_path__ + "static/media/ic-teachers.06a64c26.svg";